import { fetchQuery } from 'react-relay';

import { expValEquals } from '@confluence/feature-experiments';
import { getRelayEnvironment } from '@confluence/graphql-provider/entry-points/relayEnvironment.ts';

import PageOwnershipByLineWithCollaboratorsDropdownContentQuery, {
	type PageOwnershipByLineWithCollaboratorsDropdownContentQuery as CollaboratorsQueryType,
} from './PageOwnershipByLineWithContributorsDropdown/__generated__/PageOwnershipByLineWithCollaboratorsDropdownContentQuery.graphql.ts';
import { getContentCollaboratorsQueryVariables } from './PageOwnershipByLineWithContributorsDropdown/getContentCollaboratorsQueryVariables.ts';

export const preloadContentOwnershipCollaborators = ({
	cloudId,
	contentId,
	spaceKey,
}: {
	cloudId: string;
	contentId: string;
	spaceKey: string;
}): Promise<CollaboratorsQueryType['response'] | undefined> =>
	fetchQuery<CollaboratorsQueryType>(
		getRelayEnvironment(),
		PageOwnershipByLineWithCollaboratorsDropdownContentQuery,
		getContentCollaboratorsQueryVariables({
			cloudId,
			contentId,
			spaceKey,
			shouldIncludeJobTitle: expValEquals('cc_show_byline_job_title', 'isEnabled', true),
		}),
		{ fetchPolicy: 'store-or-network' },
	).toPromise();
